import styled from "@emotion/styled"
import { Container } from "@mui/material"

import CustomImage from "../../components/custom-image/custom-image.component"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import AnimatedText from "../../components/animated-text/animated-text.component"

export const Section = styled(SectionWrapper)`
  padding-bottom: 5rem;
  padding-top: 0;
  &.bg-color {
    background-color: ${({ theme }) => theme.palette.tertiary.main};
  }
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-bottom: 7.5rem;
  }
`
export const BgImage = styled(CustomImage)`
  width: 100%;
  height: 100%;

  > .gatsby-image-wrapper {
    height: 100%;
    img {
      border-radius: 0.75rem;
      filter: grayscale(100%);
    }
  }

  ${({ theme }) => theme.breakpoints.up("sm")} {
    > .gatsby-image-wrapper {
      height: 100%;
      img {
        border-radius: 1rem;
        filter: grayscale(100%);
      }
    }
  }
`
export const Wrapper = styled(Container)`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  position: relative;
`

export const TextWrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: space-between;
  margin-top: 1.75rem;
  width: 100%;
  ${({ theme }) => theme.breakpoints.up("sm")} {
    margin-top: 4.94rem;
  }
`

export const Title = styled(AnimatedText)`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 2rem;
  line-height: 2.5rem;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: ${({ theme }) => theme.typography.pxToRem("60")};
    line-height: ${({ theme }) => theme.typography.pxToRem("68")};
  }
  ${({ theme }) => theme.breakpoints.up("md")} {
    max-width: 315px;
  }
`

export const Description = styled.div`
  font-size: ${({ theme }) => theme.typography.pxToRem("15")};
  line-height: 1.5rem;
  letter-spacing: 0.17px;

  p {
    :last-of-type {
      margin-bottom: 0;
    }
    :first-of-type {
      margin-top: 0;
    }
  }
  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: ${({ theme }) => theme.typography.pxToRem("17")};
    line-height: 1.75rem;
  }
`
